export default __webpack_public_path__ + "static/media/PQ_RGB.c7e163d7.png";